import { clearLocalStorage, saveToken } from 'Support/services/local-storage.service';
import http from '@/support/services/HttpService';

const endpoint = '/v1/login';

function login(user) {
  return new Promise((resolve, reject) => http
    .post(endpoint, user)
    .then(({
      data,
    }) => {
      saveToken(data);
      resolve(data);
    }, (error) => {
      reject(error);
    }));
}

function logout() {
  return new Promise((resolve, reject) => http
    .post('/v1/logout')
    .then(({
      data,
    }) => {
      clearLocalStorage();
      resolve(data);
    }, (error) => {
      clearLocalStorage();
      reject(error);
    }));
}

export { login, logout };
